import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableWhiteLabel = Loadable({
  loader: function loader() {
    return import('../WhiteLabel.jsx');
  },
  loading: ComponentLoading
});
export default LoadableWhiteLabel;